<template>
  <div>
    <heads></heads>
    <div class="online-center" style="background-color: #ffffff">
      <div class="online-border">
        <div class="onlineHeight">
          <scroller :on-refresh="_refresh" height="100%"  ref="myscroller" :refreshText="$t('Online.drop')"  style="position: relative">
            <div class="online-height" id="onlineH">
              <div :class="[item.sender_id==yk_uid && item.from_type==0 ? 'online-center-chat' : 'online-center-chatLeft']" v-for="item in list">
                <img :src="item.avatar" class="online-center-img"/>
                <div :class="[item.sender_id==yk_uid && item.from_type==0 ? 'online-center-text' : 'online-center-text2']">
                  <span :class="[item.sender_id==yk_uid && item.from_type==0 ? 'online-center-title' : 'online-center-title2']" v-if="item.chat_type=='txt'" v-html="item.message"></span>
                  <span :class="[item.sender_id==yk_uid && item.from_type==0 ? 'online-center-title' : 'online-center-title2']" v-else-if="item.chat_type=='image'"><img :src="path+item.message"  @click.stop="_hidePath(1,item.message)"/></span>
                  <span class="" :class="[item.sender_id==yk_uid && item.from_type==0 ? 'online-center-time' : 'online-center-time2']">{{item.chat_time}}</span>
                </div>
              </div>
            </div>
          </scroller>

          <div class="emoji_container" v-if="isEmoji===1" @click.stop="_face(1)">
            <div class="emoji_content">
              <div class="emoji_item">
                <ul v-for="(item,index) in emojiItem">
                  <li v-for="items in item" :data-code="items.code" :data-name="items.name" :data-emoji="item.path" @click.stop="_faceText(items.name,items.code)"><img :src="globalConfig.faceUrl+items.path"/></li>
                </ul>
              </div>
              <div class="emoji_tabar">
                <ul><li>{{$t('Online.face')}}</li></ul>
              </div>
            </div>
          </div>
        </div>

        <div class="online-btn">
          <div class="online-send">
            <span class="online-send-emoji"><img src="../../assets/img/face.png" @click.stop="_face(2)"/></span>
            <span class="online-send-picture"><img src="../../assets/img/picture.png"/><input type="file" ref="inputs" accept="image/*" @change="add_img"/></span>
            <!--
             <span class="online-send-btn" @click.stop="sendMessage($event)">{{$t('Online.send')}}</span>-->
          </div>
          <div class="online-send-textarea">
            <textarea v-model="content" @keydown.enter="sendMessage($event)" :placeholder="$t('Online.test')"></textarea>
          </div>


        </div>


      </div>
    </div>
  </div>

</template>

<script>
  import heads from '../navs/headr'
    export default {
        name: "online",
      components:{heads},
      data(){
          return{
            emoji:[
              {path: '/chat/emoji/qq/0.png', code: ':', name: '微笑'}, {path: '/chat/emoji/qq/1.png', code: ':', name: '撇嘴'}, {path: '/chat/emoji/qq/2.png', code: ':', name: '色'}, {path: '/chat/emoji/qq/3.png', code: ':', name: '发呆'}, {path: '/chat/emoji/qq/4.png', code: ':', name: '得意'}, {path: '/chat/emoji/qq/5.png', code: ':', name: '流泪'},
              {path: '/chat/emoji/qq/6.png', code: ':', name: '害羞'}, {path: '/chat/emoji/qq/7.png', code: ':', name: '闭嘴'}, {path: '/chat/emoji/qq/8.png', code: ':', name: '睡'}, {path: '/chat/emoji/qq/9.png', code: ':', name: '大哭'}, {path: '/chat/emoji/qq/10.png', code: ':', name: '尴尬'},{path: '/chat/emoji/qq/11.png', code: ':', name: '发怒'},
              {path: '/chat/emoji/qq/12.png', code: ':', name: '调皮'},{path: '/chat/emoji/qq/13.png', code: ':', name: '呲牙'},{path: '/chat/emoji/qq/14.png', code: ':', name: '惊讶'}, {path: '/chat/emoji/qq/15.png', code: ':', name: '难过'}, {path: '/chat/emoji/qq/16.png', code: ':', name: '酷'}, {path: '/chat/emoji/qq/17.png', code: ':', name: '冷汗'},
              {path: '/chat/emoji/qq/18.png', code: ':', name: '抓狂'}, {path: '/chat/emoji/qq/19.png', code: ':', name: '吐'}, {path: '/chat/emoji/qq/20.png', code: ':', name: '偷笑'}, {path: '/chat/emoji/qq/21.png', code: ':', name: '可爱'}, {path: '/chat/emoji/qq/22.png', code: ':', name: '白眼'}, {path: '/chat/emoji/qq/23.png', code: ':', name: '傲慢'},
              {path: '/chat/emoji/qq/24.png', code: ':', name: '饥饿'}, {path: '/chat/emoji/qq/25.png', code: ':', name: '困'}, {path: '/chat/emoji/qq/26.png', code: ':', name: '惊恐'}, {path: '/chat/emoji/qq/27.png', code: ':', name: '流汗'}, {path: '/chat/emoji/qq/28.png', code: ':', name: '憨笑'}, {path: '/chat/emoji/qq/29.png', code: ':', name: '大兵'},
              {path: '/chat/emoji/qq/30.png', code: ':', name: '奋斗'},{path: '/chat/emoji/qq/31.png', code: ':', name: '咒骂'}, {path: '/chat/emoji/qq/32.png', code: ':', name: '疑问'}, {path: '/chat/emoji/qq/33.png', code: ':', name: '嘘'}, {path: '/chat/emoji/qq/34.png', code: ':', name: '晕'}, {path: '/chat/emoji/qq/35.png', code: ':', name: '折磨'},
              {path: '/chat/emoji/qq/36.png', code: ':', name: '衰'}, {path: '/chat/emoji/qq/37.png', code: ':', name: '骷髅'}, {path: '/chat/emoji/qq/38.png', code: ':', name: '敲打'}, {path: '/chat/emoji/qq/39.png', code: ':', name: '再见'}, {path: '/chat/emoji/qq/40.png', code: ':', name: '擦汗'}, {path: '/chat/emoji/qq/41.png', code: ':', name: '抠鼻'},
              {path: '/chat/emoji/qq/42.png', code: ':', name: '鼓掌'}, {path: '/chat/emoji/qq/43.png', code: ':', name: '糗大了'}, {path: '/chat/emoji/qq/44.png', code: ':', name: '坏笑'}, {path: '/chat/emoji/qq/45.png', code: ':', name: '左哼哼'}, {path: '/chat/emoji/qq/46.png', code: ':', name: '右哼哼'}, {path: '/chat/emoji/qq/47.png', code: ':', name: '哈欠'},
              {path: '/chat/emoji/qq/48.png', code: ':', name: '鄙视'}, {path: '/chat/emoji/qq/49.png', code: ':', name: '委屈'}, {path: '/chat/emoji/qq/50.png', code: ':', name: '快哭了'}, {path: '/chat/emoji/qq/51.png', code: ':', name: '阴险'}, {path: '/chat/emoji/qq/52.png', code: ':', name: '亲亲'}, {path: '/chat/emoji/qq/53.png', code: ':', name: '吓'},
              {path: '/chat/emoji/qq/54.png', code: ':', name: '可怜'}, {path: '/chat/emoji/qq/55.png', code: ':', name: '菜刀'}, {path: '/chat/emoji/qq/56.png', code: ':', name: '西瓜'}, {path: '/chat/emoji/qq/57.png', code: ':', name: '啤酒'}, {path: '/chat/emoji/qq/58.png', code: ':', name: '篮球'}, {path: '/chat/emoji/qq/59.png', code: ':', name: '乒乓'},
              {path: '/chat/emoji/qq/60.png', code: ':', name: '咖啡'}, {path: '/chat/emoji/qq/61.png', code: ':', name: '饭'}, {path: '/chat/emoji/qq/62.png', code: ':', name: '猪头'}, {path: '/chat/emoji/qq/63.png', code: ':', name: '玫瑰'}, {path: '/chat/emoji/qq/64.png', code: ':', name: '凋谢'}, {path: '/chat/emoji/qq/65.png', code: ':', name: '示爱'},
              {path: '/chat/emoji/qq/66.png', code: ':', name: '爱心'}, {path: '/chat/emoji/qq/67.png', code: ':', name: '心碎'}, {path: '/chat/emoji/qq/68.png', code: ':', name: '蛋糕'}, {path: '/chat/emoji/qq/69.png', code: ':', name: '闪电'}, {path: '/chat/emoji/qq/70.png', code: ':', name: '炸弹'}, {path: '/chat/emoji/qq/71.png', code: ':', name: '刀'},
              {path: '/chat/emoji/qq/72.png', code: ':', name: '足球'}, {path: '/chat/emoji/qq/73.png', code: ':', name: '瓢虫'}, {path: '/chat/emoji/qq/74.png', code: ':', name: '便便'}, {path: '/chat/emoji/qq/75.png', code: ':', name: '月亮'}, {path: '/chat/emoji/qq/76.png', code: ':', name: '太阳'}, {path: '/chat/emoji/qq/77.png', code: ':', name: '礼物'},
              {path: '/chat/emoji/qq/78.png', code: ':', name: '拥抱'}, {path: '/chat/emoji/qq/79.png', code: ':', name: '强'}, {path: '/chat/emoji/qq/80.png', code: ':', name: '弱'}, {path: '/chat/emoji/qq/81.png', code: ':', name: '握手'}, {path: '/chat/emoji/qq/82.png', code: ':', name: '胜利'}, {path: '/chat/emoji/qq/83.png', code: ':', name: '抱拳'},
              {path: '/chat/emoji/qq/84.png', code: ':', name: '哦了'}, {path: '/chat/emoji/qq/85.png', code: ':', name: '勾引'}, {path: '/chat/emoji/qq/86.png', code: ':', name: '拳头'}, {path: '/chat/emoji/qq/87.png', code: ':', name: '差劲'},
            ],
            emojiItem:[],
            isEmoji:0,
            websocket:null,
            content:'',
            yk_uid:'',
            kf_uid:this.$route.params.id,
            yk_name:'',
            list:[],
            isRoll:true,
            curPage:0,
            path:'',
            last_Page:0,
            yk_avatar:'/chat/avatar/man.jpg',
            kf_name:this.$route.query.name,
            kf_avatar:this.$route.query.avatar,
            coverPath:'',
            isCover:0,
          }
      },
      created:function(){
        let _self=this;
        if(_self.kf_uid!=''){
          let len=8;
          let result = [];
          for(var i=0;i<_self.emoji.length;i+=len){
            result.push(_self.emoji.slice(i,i+len));
          }
          _self.emojiItem=result;
          let uid=_self.GLOBAL.getCookie('uid');
          let token=_self.GLOBAL.fetch('token');
          if(uid!=null && uid!=undefined && uid!=''){
            if(token.length!=0){
              _self.yk_uid=token.id;
              _self.yk_name=token.username;
              _self.yk_avatar=token.head_img;
            }else{
              _self.yk_uid=uid;
              _self.yk_name='游客-'+_self.yk_uid;
            }
          }else{
            if(token.length!=0){
              _self.randomString();
              _self.yk_uid=token.id;
              _self.yk_name=token.username;
              _self.yk_avatar=token.head_img;
            }else{
              _self.yk_uid=_self.randomString();
              _self.yk_name='游客-'+_self.yk_uid;
            }

          }
          _self._history();
          _self._init_websocket();
          setTimeout(function() {
            var div = document.getElementById('onlineH');
            if(_self.$refs.myscroller!=undefined){
              _self.$refs.myscroller.scrollTo(0, div.clientHeight, false);
            }
          }, 1000)
        }else{
          Toast(_self.$t('Online.tip'));
          _self.$router.back();
        }

      },
      beforeRouteLeave(to,from,next){//记录离开时的位置
        this.websocket.close();
        next()
      },
      methods:{
        _refresh:function(done){
          console.log(this.isRoll)
          if (this.isRoll == false) {
            this._history();
            this.isRoll = true;
            done && done(true);
          } else {
            done && done(true);
          }
        },
        _history:function(chat_type){
          let _self=this;
          let page = parseFloat(_self.curPage) + 1;
          _self.curPage = page;
          if (_self.last_Page == 0) {
            _self.last_Page = page;
          }
          this._PublicFun.getData('1','get', 'chat/history?page='+page+"&kf_uid="+_self.kf_uid+"&yk_uid="+_self.yk_uid, {}, function (result) {
            if(result.data['status_code']==200){
              _self.path=result.data['upload_path'];
              if(chat_type=='merge' || chat_type=='del'){
                _self.list=[];
              }
              let meta = result.data['meta'];
              let b=result.data['data'];
              b=b.reverse();
              let a=_self.list;
              let c=b.concat(a);
              _self.list=c;
              if (meta.last_page <= page) {
                _self.isRoll = true;
              } else {
                _self.last_Page = meta.last_page;
                _self.isRoll = false;
              }
            }else if(result.data['status_code']==201){
              /* Toast("当前已经没有数据");*/
              _self.isRoll=true;
            }

          })
        },
        // 随机字符串方法
        randomString() {
          let _self=this;
          let len = 32;
          let chars ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          let maxPos = chars.length;
          let character = '';
          for (let i = 0; i < len; i++) {
            character += chars.charAt(Math.floor(Math.random() * maxPos))
          }
          _self.GLOBAL.setCookie('uid',character);
          return character;
        },
        _init_websocket() {
          //服务器地址
          let _self=this;
          let websocket_domain = document.location.protocol;
          /*  let url ='';*/
          let flag=_self.GLOBAL.getCookie('uid');
          let uid='';
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            uid='&uid='+token.id
          }
           /*let url="ws://mw.skyauct.com/ws?u_type=youke&flag="+flag+uid+"&kf_id="+_self.kf_uid;*/
          let url='';
          if(websocket_domain =="http:")
          {
            url = "ws://"+window.location.host+"/ws?u_type=youke&flag="+flag+uid+"&kf_id="+_self.kf_uid;
          }else if(websocket_domain == "https:")
          {
            url = "wss://"+window.location.host+"/ws?u_type=youke&flag="+flag+uid+"&kf_id="+_self.kf_uid;
          }
          //一些对浏览器的兼容已经在插件里面完成
          // window.websocket = new ReconnectingWebSocket(url);
          this.websocket = new WebSocket(url);
          this.websocket.onerror = function () {
            console.log("websocket连接异常");

          };
          //连接成功建立的回调方法
          this.websocket.onopen = function (event) {
            console.log("websocket连接成功");

          };
          //接收到消息的回调方法
          this.websocket.onmessage = function (event) {
            let data = JSON.parse(event.data);
            if(data.chat_type=='txt' || data.chat_type=='image'){
              _self.showMessage(data)
            }else if(data.chat_type=='del' || data.chat_type=='merge'){
              _self._del(data.chat_type);
            }
            // console.log(!data.type);
            // 展示消息信息
            // window.chat.showMessage(data);
          };
          //连接关闭的回调方法
          this.websocket.onclose = function () {
            _self.websocket.close();
            console.log("websocket关闭连接");
            clearInterval();
          };
          //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
          window.onbeforeunload = function () {
            _self.websocket.close();
          };
          this._start();
        },
        _start:function(){
          let _self=this;
          setInterval(function () { //每隔60秒钟发送一次心跳，避免websocket连接因超时而自动断开
            if (_self.websocket.readyState == WebSocket.CLOSED) {
              //重连websocket
              _self._init_websocket();
              console.log('重新连接');
            }
          }, 1000);
          setInterval(function () { //每隔60秒钟发送一次心跳，避免websocket连接因超时而自动断开
            // window.setTimeout(function () { //每隔60秒钟发送一次心跳，避免websocket连接因超时而自动断开
            let ping = {"type": "heart", "data": "ping"};
            _self.websocket.send(JSON.stringify(ping));

            if (_self.websocket.readyState == WebSocket.CLOSED) {
              //重连websocket
              _self._init_websocket();
            }
          }, 60000);
        },
        _face:function(m){
          let _self=this;
          if(m==1){
            _self.isEmoji=0;
          }else if(m==2){
            _self.isEmoji=1;
          }
        },
        _faceText:function(name,code){
          let _self=this;
          _self.content=_self.content+'['+code+name+']';
          _self._face(0);

        },
        sendMessage(event) {
          let _self=this;
          event.preventDefault();
          let content = _self.content;//输入信息
          let message = _self.replace_em(content);
          if (message.length <= 0) {
            Toast(_self.$t('Online.test'));
            return;
          }
          let dataObj = this.msgDataFormat('txt',message);
          //发送消息数据
          this.websocket.send(JSON.stringify(dataObj));
          //清空输入框内容
          this.content = '';
          this.isEmoji=0;
          // 发送消息提示音
        },
        //表情格式替代
        replace_em(content){
          let str=content;
          for(var i=0;i<this.emoji.length;i++){
            let emoji=this.emoji[i].code+this.emoji[i].name;
            str = str.replace(new RegExp(emoji,'g'),"<img src=\""+this.emoji[i].path+"\" />");
          }
          let m=str.replace(/\[</g,'<').replace(/[>]]/g,'>');
          return m
        },
        msgDataFormat(msg_type,message,second=0,to_uid=0){
          let _self=this;
          let flag=_self.GLOBAL.getCookie('uid');
          let dataObj = {
            "yk_avatar": _self.yk_avatar,
            'kf_avatar': _self.kf_avatar,//游客头像
            'kf_name': _self.kf_name,//客服名称
            'yk_name': _self.yk_name,//游客名称
            'yk_uid': _self.yk_uid,//游客uid
            'kf_uid': _self.kf_uid,//客服uid
            'type': msg_type,
            'message': message,
            'second': second,
            "receive_uid": _self.kf_uid,//客服uid
            "u_type": "youke",
            'sender_uid':_self.yk_uid,
            'flag':flag,
          };
          return dataObj;
        },
        showMessage:function (data) {
          let _self=this;
          _self.list.push(data);
          var div = document.getElementById('onlineH');
          if(_self.$refs.myscroller!=undefined){
            _self.$refs.myscroller.scrollTo(0, div.clientHeight, false);
          }
        },
        add_img(event) {
          let _self=this;
          var inputDOM='';
          inputDOM = _self.$refs.inputs;
          var file = inputDOM.files[0];
          var formData = new FormData();
          if(file!=''){
            formData.append('file', file);
            this._PublicFun.getData('1', 'file', 'chat/img', formData, function (result) {
              if(result.data['status_code']){
                //Toast("上传成功");
                let path=result.data['data'].path;
                let dataObj = _self.msgDataFormat('image',path);
                _self.websocket.send(JSON.stringify(dataObj));
                inputDOM.value='';
              }else{
                Toast(result.data['message']);
                inputDOM.value='';

              }

            })
          }
        },
        _del:function (chat_type) {
          let _self=this;
          _self.list=[];
          _self.curPage=0;
          _self.isRoll=true;
          _self.last_Page=0;
          _self._history(chat_type);
          if(chat_type=='del'){
            Toast(_self.$t('Online.del'));
          }
          setTimeout(function() {
            var div = document.getElementById('onlineH');
            if(_self.$refs.myscroller!=undefined){
              _self.$refs.myscroller.scrollTo(0, div.clientHeight, false);
            }
          }, 1000)
        }
      }
    }
</script>

<style scoped>
  .online-center{
    display: block;
    width: 1000px;
    margin: 10px auto;
    padding: 0;
    height: 100%;
    position: relative;
  }
  .online-border{
    border: 5px solid #EBEBEB;
  }
  .onlineHeight{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 600px;
    cursor: pointer;
    position: relative;
  }
  .online-height{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 100%;
  }
  .online-btn{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 200px;
    border-top: 1px solid #dcdcdc;
    position: relative;
  }
  .online-send{
    width: 100%;
    display: flex;
    bottom: 0;
    height: 50px;
    background-color: #eeeeee;
  }
  .online-send-emoji,.online-send-picture{
    margin-left: 10px;
    height: 50px;
    line-height: 50px;
    display: block;
    position: relative;
    cursor: pointer;
  }
  .online-send-emoji img{
    width: 30px;
    height: auto;
    vertical-align: middle;
  }
  .online-send-picture img{
    width: 25px;
    height: auto;
    vertical-align: middle;
  }
  .online-send-picture input[type=file]{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 25px;
    height: 25px;
    transform: translate(-50%,-50%);
    opacity: 0;
  }
  .online-send-textarea{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 150px;
  }
  .online-send-textarea textarea{
    display: block;
    width: 98%;
    height: 100%;
    padding: 5px 1%;
    background-color: #ffffff;
    border-radius: 5px;
    border: none;
    outline: none;
    resize: none;
  }
  .online-send-btn{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    text-align: center;
    background-color: #1E9FFF;
    color: #ffffff;
    font-size: 12px;
    height: 35px;
    line-height: 35px;
    border-radius: 5px;
  }
  .online-center-chat{
    display: flex;
    width: 90%;
    margin: 0 auto 10px;
    padding: 0;
    flex-direction: row-reverse;
    align-items: flex-start;
    position: relative;
  }
  .online-center-chatLeft{
    display: flex;
    width: 90%;
    margin: 0 auto 10px;
    padding: 0;

    align-items: flex-start;
  }
  .online-center-img{
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    object-fit: cover;
    object-position: center;
  }
  .online-center-text{
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .online-center-text2{
    padding-left: 15px;
    display: flex;
    flex-direction: column;
    position: relative;

  }
  .online-center-title{
    background: #e5f5e1;
    border-radius: 5px;
    padding: 10px 15px;
    height: 100%;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
  .online-center-title2{
    background: lightskyblue;
    border-radius: 5px;
    padding: 10px 15px;
    height: 100%;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
  .online-center-title img,.online-center-title2 img{
    max-height: 100px;
    max-width: 100px;
    width: auto;
    height: auto;
  }
  .online-center-time{
    color: #bfbfbf;
    font-size: 13px;
  }
  .online-center-time2{
    color: #bfbfbf;
    font-size: 13px;
  }
  .emoji_container{
    position: absolute;
    overflow: hidden;
    display: block;
    left: 0;
    right: 0;
    height: 245px;
    max-width: 400px;
    bottom: 0;
    z-index: 99;
    border: 1px solid #bfbfbf;
    background-color: #efefef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.176);
  }
  .emoji_content{
    margin-top: 7px;
    padding-left: 2px;
    padding-right: 2px;
  }
  .emoji_item{
    padding: 1px;
    margin: 0;
    float: left;
    width: 100%;
    height: 195px;
    overflow: hidden;
    overflow-y: scroll;
    background-color: #fefefe;
    border-collapse: collapse;
  }
  .emoji_item ul{
    list-style: none;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    padding-top: 1px;
  }
  .emoji_item ul li{
    padding: 5px;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: -1px;
    margin-top: -1px;
    border: 1px solid rgba(177, 177, 177, 0.4);
  }
  .emoji_item ul li img{
    vertical-align: middle;
    max-width: 28px;
    max-height: 28px;
    margin: 0 auto;
    display: block;
  }
  .emoji_tabar{
    border-top: 1px solid rgba(177, 177, 177, 0.4);
    width: 100%;
    height: 38px;
    clear: both;
    margin: 0;
    background-color: #efefef;
  }
  .emoji_tabar ul{
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .emoji_tabar ul li{
    display: inline-block;
    padding: 5px;
    height: 100%;
    background-color: rgba(177, 177, 177, 0.1);
    border-right: 1px solid rgba(177, 177, 177, 0.4);
    border-radius: 3px;
    margin-left: 0;
  }
  .cover-Big{
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    top: 0;
    z-index: 99;
    text-align: center;
    background-color: rgba(0,0,0,0.2);
  }
  .cover-Big div{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
  }
  .cover-Big img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/online.vue